module.exports = __webpack_public_path__ + "static/img/report_img_xxxmtkbg.2d91ff7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/report_img_xxxmtkbg.png
// module id = 8u2X
// module chunks = 21